// extracted by mini-css-extract-plugin
export default {"imagePreviewContainer":"ImagePreview_imagePreviewContainer__BrUfD","dialogueContainer":"ImagePreview_dialogueContainer__rwYMx","image":"ImagePreview_image__e8dN8"};